import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { CellPhone, Phone, PhoneInputViewModel } from "src/common/utilities/phoneInput/phoneInput-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { TranslatorConverter } from "src/TranslatorConverter";
import { ServerSideDataLoader, PaginationInfo, Enum, IEnumTranslator } from "uicomponents";
import { ConfirmCustomerRequestViewModel } from "../confirmCustomerRequest/confirmCustomerRequest-viewModel";
import  { CustomerCreationRequestManipulationView } from "./customerCreationRequestManipulation-view"
import { CustomerAttribute } from "../customerAttribute/customerAttributesSelector-viewModel";

export class CustomerCreationRequestManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت درخواست‌های ایجاد مشتری ‌';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.requestStateEnumProvider = new CustomerRequestStateEnumProvider();
        this.customerCreationRequests = ObservableArray.create<CustomerCreationRequest>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new CustomerCreationRequestManipulationView();
    }
    public getTypeId(): string {
        return "VM-40B4C578-A288-4741-BC5E-0D7FE2A26D1F"
    }
    public set requestStateEnumProvider(v: CustomerRequestStateEnumProvider) { this._requestStateEnumProvider = v; } public get requestStateEnumProvider(): CustomerRequestStateEnumProvider { return this._requestStateEnumProvider;} private _requestStateEnumProvider: CustomerRequestStateEnumProvider;
    public set customerCreationRequests(v: ObservableArray<CustomerCreationRequest>) { this._customerCreationRequests = v; } public get customerCreationRequests(): ObservableArray<CustomerCreationRequest> { return this._customerCreationRequests;} private _customerCreationRequests: ObservableArray<CustomerCreationRequest>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    refresh(){
        this.loader.refresh();
    }
    
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            if(filteringInformation.OrderInfo.length == 0)
            {
                let sort = {
                    fieldName:'creationTime',
                    order:'DESC',
                    type:'date'
                };
                filteringInformation.OrderInfo = [sort];
            }
            let result = await ServerConnection.callServer('/Complex/CrmServices/GetAllCustomerCreationRequest',{
                FilteringInformation:filteringInformation
            });
            
            this.customerCreationRequests.update(...result.CustomerCreationRequest.map((q,rowNumber)=>{
                let r = new CustomerCreationRequest(this);
                r.id = q.Id;
                r.rowNumber = rowNumber+1;
                r.name = q.Name;
                r.lastName = q.LastName;
                r.fullName = `${q.Name} ${q.LastName}`;
                r.nationalCode = q.NationalCode;
                r.address = q.Address;
                r.comment = q.Comment;
                r.districtId = q.DistrictId;
                r.districtName = q.DistrictName;
                r.provinceId = q.ProvinceId;
                r.provinceName = q.ProvinceName;
                r.cityId = q.CityId;
                r.cityName = q.CityName;
                r.cellphones.update(...q.CellPhones.map(x=>{
                    let p = new CellPhone(r.phoneInput);
                    p.countryCode = x.CountryCode;
                    p.number = x.Number;
                    return p;
                }));
                r.customerAttributes.update(...q.AttributeValues.map(x=>{
                    let p = new CustomerAttribute(this);
                    p.id = x.Id;
                    p.title = x.Name;
                    return p;
                }));
                r.phones.update(...q.Phones.map(x=>{
                    let p = new Phone(r.phoneInput);
                    p.countryCode = x.CountryCode;
                    p.number = x.Number;
                    p.cityCode = x.CityCode;
                    return p;
                }));
                
                r.phoneInput.addCellPhone(...r.cellphones);
                r.phoneInput.addPhone(...r.phones);

                r.creationTime = moment.utc(q.CreationTime);
                r.determinationTime = q.DeterminationTime==null ? null : moment.utc(q.DeterminationTime);
                r.creatorId = q.CreatorId;
                r.creatorName = q.CreatorName;
                r.determinatorId = q.DeterminatorId;
                r.determinatorName = q.DeterminatorName;
                r.state = q.State;
                r.needConfirm = q.DeterminationTime ==null ? true : false;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    
    async save(customerCreationRequest:CustomerCreationRequest){
        let editor = new customerCreationRequestEditor(this,new InsertServerUpdater());
        editor.id = customerCreationRequest.id;
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async confirmRequest(confirmRequested:CustomerCreationRequest) {
        let inserter = await new ConfirmCustomerRequestViewModel(this);
        inserter.cloneTo(confirmRequested);
        let resultCode = await this.showPopup(inserter);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }

    async rejectSelected(selectedId:any):Promise<void>{
        let result:string; 
        result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','رد کردن درخواست ها');
        if(result=='yes'){
            try {
                this.isLoading = true;
                await ServerConnection.callServer('/Complex/CrmServices/RejectCustomerCreationRequest',{
                    Id: selectedId
                });
                await this.messageBoxConfirmSuccess('درخواست رد شد.','عملیات موفق');
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            } finally {
                this.isLoading = false;
                this.loader.refresh();
            }
        }
    }

}

export class ShowCustomerPhones extends CustomerCreationRequestManipulationViewModel implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:CustomerCreationRequestManipulationViewModel, phones:string) {
        super(parent);
        
    }
    closePopup(resultCode: string = null) {
    }
    
}

export class CustomerCreationRequest extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:CustomerCreationRequestManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        this.phoneInput = new PhoneInputViewModel(this);
        this.phones = ObservableArray.create<Phone>();
        this.cellphones = ObservableArray.create<CellPhone>();
        this.customerAttributes = ObservableArray.create<CustomerAttribute>();
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set lastName(v: string) { this._lastName = v; } public get lastName(): string { return this._lastName;} private _lastName: string;
    public set fullName(v: string) { this._fullName = v; } public get fullName(): string { return this._fullName;} private _fullName: string;
    public set nationalCode(v: string) { this._nationalCode = v; } public get nationalCode(): string { return this._nationalCode;} private _nationalCode: string;
    public set address(v: string) { this._address = v; } public get address(): string { return this._address;} private _address: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId;} private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set provinceId(v: string) { this._provinceId = v; } public get provinceId(): string { return this._provinceId;} private _provinceId: string;
    public set provinceName(v: string) { this._provinceName = v; } public get provinceName(): string { return this._provinceName;} private _provinceName: string;
    public set cityId(v: string) { this._cityId = v; } public get cityId(): string { return this._cityId;} private _cityId: string;
    public set cityName(v: string) { this._cityName = v; } public get cityName(): string { return this._cityName;} private _cityName: string;
    public set phoneInput(v: PhoneInputViewModel) { this._phoneInput = v; } public get phoneInput(): PhoneInputViewModel { return this._phoneInput;} private _phoneInput: PhoneInputViewModel;
    public set phones(v: ObservableArray<Phone>) { this._phones = v; } public get phones(): ObservableArray<Phone> { return this._phones;} private _phones: ObservableArray<Phone>;
    public set cellphones(v: ObservableArray<CellPhone>) { this._cellphones = v; } public get cellphones(): ObservableArray<CellPhone> { return this._cellphones;} private _cellphones: ObservableArray<CellPhone>;
    public set customerAttributes(v: ObservableArray<CustomerAttribute>) { this._customerAttributes = v; } public get customerAttributes(): ObservableArray<CustomerAttribute> { return this._customerAttributes;} private _customerAttributes: ObservableArray<CustomerAttribute>;
    
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime;} private _creationTime: moment.Moment;
    public set determinationTime(v: moment.Moment) { this._determinationTime = v; } public get determinationTime(): moment.Moment { return this._determinationTime;} private _determinationTime: moment.Moment;
    public set creatorId(v: string) { this._creatorId = v; } public get creatorId(): string { return this._creatorId;} private _creatorId: string;
    public set creatorName(v: string) { this._creatorName = v; } public get creatorName(): string { return this._creatorName;} private _creatorName: string;
    public set determinatorId(v: string) { this._determinatorId = v; } public get determinatorId(): string { return this._determinatorId;} private _determinatorId: string;
    public set determinatorName(v: string) { this._determinatorName = v; } public get determinatorName(): string { return this._determinatorName;} private _determinatorName: string;
    public set state(v: number) { this._state = v; } public get state(): number { return this._state;} private _state: number;
    public set needConfirm(v: boolean) { this._needConfirm = v; } public get needConfirm(): boolean { return this._needConfirm;} private _needConfirm: boolean;
    public set selected(v: boolean) { this._selected = v; } public get selected(): boolean { return this._selected;} private _selected: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  
    
    private _typedParent:CustomerCreationRequestManipulationViewModel;

    async confirmRequest() {
        this._typedParent.confirmRequest(this);
    }

    async rejectRequest(){
        this._typedParent.rejectSelected(this.id);
    } 
    
}

interface IServerUpdater{
    execute(customerCreationRequest:CustomerCreationRequest):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'مشتری با موفقیت ثبت شد.';
    }

    async execute(customerCreationRequest: CustomerCreationRequest): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/CrmServices/ConfirmCustomerCreationRequest',{
            CustomerCreationRequestId:customerCreationRequest.id,
        });
        if(result.IsSuccessful==false){
            if(result.IsSuccessful==false){
                if (result.Faults[0].Parameters.FaultId === "096473E7-67AE-4206-9B61-79B70943684A")
                    throw "این مشتری قبلا تعریف شده است";
            }
        }
    }

}

export class customerCreationRequestEditor extends CustomerCreationRequest implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:CustomerCreationRequestManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    async save(){
        try {
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex,'خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }
}

export class CustomerRequestStateEnumProvider extends Enum implements IEnumTranslator{
    constructor() {
        super();
        this.values = [1,2,3];
        this.translator = this;
        this.converter = new TranslatorConverter(); 
    }
    private converter:TranslatorConverter;
    GetString(value: any) {
        return this.converter.translateCustomerRequestState(value);
    }
}

